import BannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'
import blupaxLogo from '../../assets/images/AuthorizedDistributor/blupax_logo.png'
import fffLogo from '../../assets/images/AuthorizedDistributor/FFF_Logo.png'
import henryScheinLogo from '../../assets/images/AuthorizedDistributor/henryschein_logo.jpeg'
import medicomartLogo from '../../assets/images/AuthorizedDistributor/Medicomart_Logo.png'
import prodigyHealthLogo from '../../assets/images/AuthorizedDistributor/Prodigy_Health.png'

export const authorizedDistributorContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
      {
        "fields": {
          "name": "Moderna Authorized Distributors",
          "title": "Moderna Authorized Distributors",
          "slug": "authorized-distributor",
          "content": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "4ARxG96zNbND41UTYkRMXi",
              "type": "Entry",
              "createdAt": "2023-08-24T18:28:21.731Z",
              "updatedAt": "2023-08-24T18:28:21.731Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 3,
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "richTextContentPageTemplate"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "Moderna Authorized Distributors > Rich Text",
              "modules": [
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "6YWTBwpSUIAbRG131F5gjc",
                    "type": "Entry",
                    "createdAt": "2023-08-24T18:27:45.066Z",
                    "updatedAt": "2023-08-24T18:27:45.066Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 4,
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Moderna Authorized Distributors > Rich Text > Banner",
                    "headline": "Moderna Authorized Distributors",
                    "backgroundImage": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "1Px4l8fvDKjBGrRTCqfWrE",
                        "type": "Asset",
                        "createdAt": "2022-12-29T16:44:45.722Z",
                        "updatedAt": "2022-12-29T16:44:45.722Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 5,
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Banner BG strand top right",
                        "description": "Banner BG strand top right",
                        "file": {
                          "url": BannerStrand,
                          "details": {
                            "size": 47693,
                            "image": {
                              "width": 1920,
                              "height": 511
                            }
                          },
                          "fileName": "Banner_BG_strand_right.png",
                          "contentType": "image/png"
                        }
                      }
                    },
                    "country": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "7sht7920U6vs3CLH2CUyaa",
                        "type": "Entry",
                        "createdAt": "2023-05-18T03:23:50.744Z",
                        "updatedAt": "2023-05-24T22:55:23.250Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "country"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "United States",
                        "isocode": "US",
                        "flag": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                            "type": "Asset",
                            "createdAt": "2023-05-24T22:54:50.939Z",
                            "updatedAt": "2023-05-24T22:54:50.939Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 5,
                            "revision": 1,
                            "locale": "en-US"
                          },
                          "fields": {
                            "title": "usa flag",
                            "description": "USA Flag",
                            "file": {
                              "url": usaFlag,
                              "details": {
                                "size": 2487,
                                "image": {
                                  "width": 36,
                                  "height": 26
                                }
                              },
                              "fileName": "usa_flag.svg",
                              "contentType": "image/svg+xml"
                            }
                          }
                        },
                        "locales": [
                          "en-US"
                        ]
                      }
                    }
                  }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "6Zphv8XyZ3pLwqIvNbqUJS",
                    "type": "Entry",
                    "createdAt": "2023-08-24T18:28:17.984Z",
                    "updatedAt": "2024-08-09T18:38:34.853Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 109,
                    "revision": 23,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Moderna Authorized Distributors > Rich Text > Rich Text Content",
                    "content": {
                      "nodeType": "document",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Moderna collaborates with a network of authorized distributors dedicated to ensuring the distribution of our products. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "These distributors are carefully selected based on their commitment to quality, service, and compliance with regulatory standards",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ". They play a crucial role in our supply chain, helping to deliver our products safely and efficiently to healthcare professionals.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "hr",
                          "data": {},
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "P.E.R.K. Program Partners: ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "P.E.R.K. Program partners are distributors who share our commitment to delivering an exceptional experience for you - including superior service, streamlined processes for onboarding, faster shipping options, and overall distribution expertise. P.E.R.K. partners are highlighted below.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "3XwtMAaxeZ6gu0FkSuaMVs",
                                "type": "Asset",
                                "createdAt": "2024-07-08T13:13:47.262Z",
                                "updatedAt": "2024-07-08T13:13:47.262Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 5,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "BluPax Logo",
                                "description": "",
                                "file": {
                                  "url": blupaxLogo,
                                  "details": {
                                    "size": 22936,
                                    "image": {
                                      "width": 262,
                                      "height": 68
                                    }
                                  },
                                  "fileName": "blupax_logo.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.blupaxpharma.com/web/login"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "BluPax",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 732-902-6760 \nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:info@blupaxpharma.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "info@blupaxpharma.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "5snOVjuY5LkFkeflnOw9sb",
                                "type": "Asset",
                                "createdAt": "2024-07-08T13:14:13.653Z",
                                "updatedAt": "2024-07-08T13:14:13.653Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "FFF Enterprises Logo",
                                "description": "",
                                "file": {
                                  "url": fffLogo,
                                  "details": {
                                    "size": 11533,
                                    "image": {
                                      "width": 284,
                                      "height": 100
                                    }
                                  },
                                  "fileName": "FFF Logo.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://ordermyflu.myfluvaccine.com/search?sortCode=relevance&query=:relevance:vaccineType:Covid:manufacturerName:MODERNA%2BUS,%2BINC."
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "FFF Enterprises",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-843-7477 \nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:fffcustomercare@fffenterprises.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "fffcustomercare@fffenterprises.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "1K6nWFIztprc2rwvDT6C0N",
                                "type": "Asset",
                                "createdAt": "2024-08-09T18:38:31.793Z",
                                "updatedAt": "2024-08-09T18:38:31.793Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 6,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Henry Schein Logo",
                                "description": "",
                                "file": {
                                  "url": henryScheinLogo,
                                  "details": {
                                    "size": 2931,
                                    "image": {
                                      "width": 200,
                                      "height": 26
                                    }
                                  },
                                  "fileName": "henryschein logo.jpeg",
                                  "contentType": "image/jpeg"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.henryschein.com/us-en/medical/m/moderna-us-inc"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Henry Schein",
                                  "marks": [
                                    {
                                      "type": "bold"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-472-4346",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "3DFi4hceLxatmpQX8UH6vZ",
                                "type": "Asset",
                                "createdAt": "2024-06-12T13:28:46.819Z",
                                "updatedAt": "2024-06-12T13:28:46.819Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Medicomart Logo",
                                "description": "",
                                "file": {
                                  "url": medicomartLogo,
                                  "details": {
                                    "size": 10280,
                                    "image": {
                                      "width": 278,
                                      "height": 39
                                    }
                                  },
                                  "fileName": "Medicomart Logo.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.medicomart.com/moderna"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Medico Mart",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-242-6248",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "53Y7lrva8ADfIDnidpZl6I",
                                "type": "Asset",
                                "createdAt": "2024-03-07T18:49:44.901Z",
                                "updatedAt": "2024-03-07T18:49:44.901Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 2,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Prodigy Health",
                                "file": {
                                  "url": prodigyHealthLogo,
                                  "details": {
                                    "size": 25812,
                                    "image": {
                                      "width": 326,
                                      "height": 98
                                    }
                                  },
                                  "fileName": "Prodigy_Health.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.prodigyhealth.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Prodigy Health",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-877-693-4376",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "hr",
                          "data": {},
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Full list of authorized distributors:",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Moderna does not authorize any distributor without proper vetting, ensuring the integrity and quality of our products.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://asdorder.amerisourcebergen.com/btstoreui/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "AmerisourceBergen/ASD",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-746-6273 \nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:service@asdhealthcare.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "service@asdhealthcare.com",
                                  "marks": [
                                    {
                                      "type": "underline"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.blupaxpharma.com/web/login"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "BluPax",
                                  "marks": [
                                    {
                                      "type": "bold"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 732-902-6760 \nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:info@blupaxpharma.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "info@blupaxpharma.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://market.cardinalhealth.com/login?RelayState=https:%2F%2Fmarket.cardinalhealth.com%2Fhome"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Cardinal Health",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-926-3161",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://ordermyflu.myfluvaccine.com/search?sortCode=relevance&query=:relevance:vaccineType:Covid:manufacturerName:MODERNA%2BUS,%2BINC."
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "FFF Enterprises",
                                  "marks": [
                                    {
                                      "type": "bold"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-843-7477 \nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:fffcustomercare@fffenterprises.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "fffcustomercare@fffenterprises.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.henryschein.com/us-en/medical/m/moderna-us-inc"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Henry Schein",
                                  "marks": [
                                    {
                                      "type": "bold"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-472-4346",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.lwdrx.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Louisiana Wholesale Drug",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-960-3784\nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:info@lwdrx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "info@lwdrx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://mms.mckesson.com/catalog?query=moderna&searchWithin=FALSE"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "McKesson MedSurge",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-855-571-2100",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://connect.mckesson.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "McKesson Plasma & Biologics",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-855-625-6285",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.medicomart.com/moderna"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Medico Mart",
                                  "marks": [
                                    {
                                      "type": "bold"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-242-6248",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.medline.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Medline",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-633-5463",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.morrisdickson.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Morris & Dickson",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-388-3833 \nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:customerservice@morrisdickson.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "customerservice@morrisdickson.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://mutualdrug.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Mutual Drug",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-800-8551",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.prodigyhealth.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Prodigy Health",
                                  "marks": [
                                    {
                                      "type": "bold"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-877-693-4376",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://www.toprx.com/"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "TopRx",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "\nPhone: 1-800-542-8677\nEmail: ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:customerservice@toprx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "customerservice@toprx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Want to order direct? Our ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "https://modernadirect.com/contact-us"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "customer care team",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": " is here to support you. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        }
                      ]
                    },
                    "printButtonLabel": "Print",
                    "country": "[Circular Reference]"
                  }
                }
              ]
            }
          }
        },
        "sys": {
          "id": "5nUo6guLfyby4N7ssIMC3G",
          "type": "Entry"
        }
      }
    ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
}